// Suppress console output unless localStorage.debugOn is set
const origLog = console.log;
const origWarn = console.warn;
const origError = console.error;
const isDebug = () => localStorage.getItem('debugOn') !== null;
console.log = (...args) => { if (isDebug()) origLog.apply(console, args); };
console.warn = (...args) => { if (isDebug()) origWarn.apply(console, args); };
console.error = (...args) => { if (isDebug()) origError.apply(console, args); };
